import React from 'react';
import { Button, HStack, Text } from '@chakra-ui/react';
import { AppleIcon, GoogleIcon, FacebookIcon } from '@/components/icons/OAuthIcons';

export interface SocialAuthButtonProps {
  provider: 'google' | 'apple' | 'facebook';
  onPress: () => void;
  disabled?: boolean;
  testID?: string;
}

const providerConfig: Record<
  SocialAuthButtonProps['provider'],
  { label: string; Icon: (props: { size?: number }) => React.JSX.Element }
> = {
  google: { label: 'Google', Icon: GoogleIcon },
  apple: { label: 'Apple', Icon: AppleIcon },
  facebook: { label: 'Facebook', Icon: FacebookIcon },
};

export function SocialAuthButton({
  provider,
  onPress,
  disabled = false,
  testID,
}: SocialAuthButtonProps) {
  const config = providerConfig[provider];
  const Icon = config?.Icon;

  return (
    <Button
      onClick={onPress}
      isDisabled={disabled}
      w="100%"
      h="48px"
      borderRadius="60px"
      bg="white"
      color="onboarding.plum"
      border="1px solid"
      borderColor="onboarding.plum"
      fontWeight="500"
      fontSize="15px"
      _hover={{ bg: 'gray.50' }}
      _active={{ bg: 'gray.100' }}
      data-testid={testID}
    >
      <HStack spacing={3} align="center">
        {Icon && <Icon size={18} />}
        <Text>Continue with {config?.label ?? provider}</Text>
      </HStack>
    </Button>
  );
}

export default SocialAuthButton;
